/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.identity.resolveDid'

export { $nsid }

/** Resolves DID to DID document. Does not bi-directionally verify handle. */
const main = l.query(
  $nsid,
  l.params({ did: l.string({ format: 'did' }) }),
  l.jsonPayload({ didDoc: l.lexMap() }),
  ['DidNotFound', 'DidDeactivated'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
